// extracted by mini-css-extract-plugin
export default {"unit":"CoolingCircutsPreview_unit__zEOpo"};